"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getDestContentKeys = getDestContentKeys;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// This function creates the new content keys array for the group in which content is being moved into
function getDestContentKeys(contentToMove, srcGroupKey, destGroupKey, groupData, siblingContent) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = groupData[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var item = _step.value;

            if (item.groupKey === destGroupKey) {
                if (!item.contentKeys) {
                    item.contentKeys = [];
                }
                // If you are moving within the same group...
                if (srcGroupKey === destGroupKey) {
                    item.contentKeys.splice(item.contentKeys.indexOf(contentToMove), 1);
                }
                if (siblingContent) {
                    item.contentKeys.splice(item.contentKeys.indexOf(siblingContent), 0, contentToMove);
                    return item.contentKeys;
                }
                return [].concat(_toConsumableArray(item.contentKeys), [contentToMove]);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return [];
}


//////////////////
// WEBPACK FOOTER
// ./~/@getgo/webinar.com-frontend-redux/lib/helpers/drag-and-drop-helper.js
// module id = 762
// module chunks = 0